import React from "react";
import {
  AuthenticationManager,
  ResourceID,
} from "../../../common/AuthenticationManager";
import { Link } from "react-router-dom";
import { StringHelper } from "../../../common/Helpers";
import { BaseListing } from "../../common/BaseListing";
import { formatPromotionCategoryName } from "../common/WebsiteManagementConstants";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";

export class PromotionListing extends BaseListing {
  constructor() {
    super();
    this.state = {
      name: "",
    };
  }

  getApiPath = () => "/api/v1/promotions";

  getDefaultSort = () => "-UpdatedOn";

  getNavigationSettings = () => {
    return new NavigationSettings({
      parentModule: new NavigationItem({
        identifier: "website_managements",
        name: "Website Management",
      }),
      activeModule: new NavigationItem({
        identifier: "promotions",
        name: "Promotions",
      }),
    });
  };

  injectSearchTerm(queryParameters) {
    const name = StringHelper.isNullOrEmpty(this.state.name)
      ? ""
      : this.state.name;
    return super.injectSearchTerm(queryParameters, { name });
  }

  onRowClick = (id) => {
    this.props.history.push(`/promotions/${id}`);
  };

  onTextBoxChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  generateTableContent() {
    return (
      <>
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Display Start</th>
            <th>Display End</th>
            <th>
              Display Weight{" "}
              <i
                className="sort-button fas fa-sort-alpha-down"
                id="DisplayWeight"
                onClick={this.toggleSort}
              />
            </th>
            <th>
              Updated On{" "}
              <i
                className="sort-button fas fa-sort-alpha-down"
                id="UpdatedOn"
                onClick={this.toggleSort}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {this.state.data
            ? this.state.data.map((item, index) => {
                return (
                  <tr key={index} onClick={() => this.onRowClick(item.id)}>
                    <td>{item.name}</td>
                    <td>{formatPromotionCategoryName(item.category)}</td>
                    <td>
                      {StringHelper.asDateStringToDisplayDateTimeFormat(
                        item.displayStartTime
                      )}
                    </td>
                    <td>
                      {StringHelper.asDateStringToDisplayDateTimeFormat(
                        item.displayEndTime
                      )}
                    </td>
                    <td>{item.weightDisplay}</td>
                    <td>
                      {StringHelper.asDateStringToDisplayDateTimeFormat(
                        item.updatedOn
                      )}
                    </td>
                  </tr>
                );
              })
            : null}
        </tbody>
      </>
    );
  }

  generateExtendedComponents() {
    return (
      <div className="row mb-3">
        <div className="col-lg-9 input-group ml-auto justify-content-end">
          <div className="mb-2 d-flex flex-fill">
            <input
              type="text"
              id="input1-group2"
              name="name"
              placeholder="Search"
              className="form-control"
              onKeyDown={this.onKeyDownSearchInput}
              onChange={this.onTextBoxChange}
              value={this.state.name}
            />
            <div className="input-group-btn">
              <button className="btn btn-primary" onClick={this.search}>
                <i className="fa fa-search" aria-hidden="true"></i> Search
              </button>
            </div>
          </div>
          {AuthenticationManager.isAuthorized(
            ResourceID.PromotionCreateButtonPage
          ) && (
            <Link
              className="btn btn-primary ml-md-2 mb-2 flex-fill max-md-width"
              to="/promotions/create"
              style={{ fontSize: "1rem" }}
            >
              <i className="fa fa-plus-circle"></i> Create Promotion
            </Link>
          )}
          <Link
            className="btn btn-primary ml-md-2 mb-2 flex-fill max-md-width"
            to="/promotions/schedules"
            style={{ fontSize: "1rem" }}
          >
            Scheduled Publishing
          </Link>
        </div>
      </div>
    );
  }
}
